import { render } from "./ListDisciplinesActionButtonsRenderer.vue?vue&type=template&id=5af4d573"
import script from "./ListDisciplinesActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListDisciplinesActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__